import * as React from "react";
import {
  Autocomplete,
  Backdrop,
  Box,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import globalClasses from "../../commoncomponents/css/Global.module.css";
import classes from "./OrganizationInfo.module.css";
import CircularProgress from "@mui/material/CircularProgress";
import { useCallback, useEffect, useRef, useState } from "react";
import { getRequest, singoutHandler } from "../../../api/AxiosAPICall";
import axios from "axios";
import CommonCard from "../../commoncomponents/layout/card/CommonCard";
import InputField from "../../commoncomponents/input/InputField";
import DialogCard from "../../commoncomponents/dialogcard/DialogCard";
import SelectField from "../../commoncomponents/dropdown/SelectField";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ButtonComponent from "../../commoncomponents/buttons/ButtonComponent";
import Progress from "../progressbar/RegistrationProgressBar";
import { emailRegex } from "../../commoncomponents/input/Regex";
import { restictDotHyphenAnde } from "../../../util/GenralUtils";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../commoncomponents/alert/SnackbarAction";
import { useNavigate } from "react-router-dom";
import { nanoid } from 'nanoid';

const OrganizationInfo = ({
  formik,
  mode,
  buttonDisplay,
  checkDuplicate,
  isEstablishmentPresent,
}: {
  formik: any;
  mode: any;
  buttonDisplay: any;
  checkDuplicate: any;
  isEstablishmentPresent: any;
}) => {
  const [verifySuccess, setVerifySuccess] = useState("");
  const [countries, setCountries] = useState<any>([]);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [csdId, setCsdId] = useState("");
  const [isVerificationCode, setIsVerificationCode] = useState(false);
  const [isCodeInvalid, setIsCodeInvalid] = useState(false);
  const [fetchDistrict, setFetchDistrict] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowButton, isSetShowButton] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [showCellmaFlexOrganizationType, setShowCellmaFlexOrganizationType] =
    useState(0);

  let cancelToken: any;
  const isMounted = useRef<any>();
  let history = useNavigate();
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();
  const searchDistrict = async (event: any) => {
    const searchText = event.target.value;
    if (searchText.length >= 3) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Canceling the previous request");
      }

      cancelToken = axios.CancelToken.source();
      setIsLoading(true);
      const response = await getRequest("districtSearch", {
        cancelToken: cancelToken.token,
        params: {
          districtString: searchText,
        },
      });
      setIsLoading(false);
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        setFetchDistrict([]);
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setFetchDistrict(response?.data);
      }
    } else {
      setFetchDistrict([]);
    }
  };

  const fetchEstSetting = async () => {
    const response = await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "show_cellmaflex_organization_type",
      },
    });
    setShowCellmaFlexOrganizationType(response?.data);
  };

  useEffect(() => {
    fetchEstSetting();
  }, []);

  const fetchCountries = useCallback(async () => {
    const response = await getRequest("contries", {});
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else {
      setCountries(response?.data);
    }

    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    isMounted.current = true;

    fetchCountries();
    return () => {
      isMounted.current = false;
      setCountries([]);
    };
    // eslint-disable-next-line
  }, []);

  const fetchEstablishmentData = useCallback(async () => {
    setOpen(true);
    const response = await getRequest("establishment", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      formik.setFieldValue(
        "organizationId",
        response?.data.addressJson.addEstId
      );
      formik.setFieldValue("organizationName", response?.data.estName);

      formik.setFieldValue("identifier", response?.data.estCodePreferences);

      if (
        countries !== null &&
        countries !== "" &&
        response?.data.addressJson.addAddress6 !== undefined
      ) {
        let isMatched = false;

        countries.forEach((element: any) => {
          if (element.couCountry === response?.data.addressJson.addAddress6) {
            isMatched = true;

            return false;
          }
        });

        if (!isMatched) {
          const addAddress = {
            couId: nanoid(),
            couCountryCode: "",
            couCountry: response?.data.addressJson.addAddress6,
            couIcaoCountryCode: "",
          };
          setCountries([...countries, addAddress]);
          formik.setFieldValue(
            "country",
            response?.data.addressJson.addAddress6
          );
        } else {
          formik.setFieldValue(
            "country",
            response?.data.addressJson.addAddress6
          );
        }
      }

      formik.setFieldValue(
        "numberRoad",
        response?.data.addressJson.addAddress1
      );

      formik.setFieldValue("district", response?.data.addressJson.addAddress2);

      formik.setFieldValue("town", response?.data.addressJson.addAddress3);

      formik.setFieldValue("county", response?.data.addressJson.addAddress4);

      formik.setFieldValue("postCode", response?.data.addressJson.addAddress5);
      formik.setFieldValue("phoneNo", response?.data.addressJson.addPhone);

      formik.setFieldValue("mobile", response?.data.addressJson.addMobile);

      formik.setFieldValue("emailId", response?.data.addressJson.addEmail);

      formik.setFieldValue("estType", response?.data?.estType);
    }
    setOpen(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    isMounted.current = true;

    if (mode === "edit") {
      fetchEstablishmentData();
    }
    return () => {
      isMounted.current = false;
      setOpen(false);
    };
    // eslint-disable-next-line
  }, [mode]);
  const sendVerificationCode = async (values: any) => {
    formik.setFieldTouched("emailId", true, true);
    if (emailRegex.test(values.emailId)) {
      setIsSendingEmail(true);
      setOpenDialog(true);
      const response = await getRequest("sendVerificationCode", {
        params: {
          email: values.emailId,
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        formik.setFieldValue("verificationCode", "");
        setInterval(() => {
          isSetShowButton(true);
        }, 18000);
        setIsVerificationCode(true);
        setOpenDialog(true);
        setIsSendingEmail(false);
        setCsdId(response.data);
      }

      if (
        response.data === null ||
        response.data === undefined ||
        response.data === ""
      ) {
        setOpenDialog(false);
        setIsVerificationCode(false);
        setIsSendingEmail(false);

        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Unable to send email",
            "top",
            "center"
          )
        );
      }
    }
  };

  const checkVerificationCode = async (values: any) => {
    if (values?.verificationCode !== "") {
      const response = await getRequest("checkVerificationCode", {
        params: {
          verificationCode: values.verificationCode,
          csdId: csdId,
        },
      });

      if (response?.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response?.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else if (Boolean(response?.data)) {
        setIsVerificationCode(false);
        setIsSendingEmail(false);
        setOpenDialog(false);
        setVerifySuccess("verify");
        buttonDisplay();
      } else {
        setVerifySuccess("notverify");
        setIsCodeInvalid(true);
      }
    }
  };

  return (
    <React.Fragment>
      {mode !== "edit" && <Progress activeStep={0} />}
      <CommonCard>
        {showCellmaFlexOrganizationType === 1 && (
          <Grid container spacing={2}>
            <Stack
              direction={{ xs: "row", sm: "row" }}
              spacing={{ xs: 1, sm: 2, md: 2 }}
              sx={{ padding: "20px" }}
            >
              <ButtonComponent
                label="Public"
                variant={
                  formik?.values?.estType === "public"
                    ? "contained"
                    : "outlined"
                }
                type=""
                onClick={() => {
                  formik.setFieldValue("estType", "public");
                }}
              />
              <ButtonComponent
                label="Private"
                variant={
                  formik?.values?.estType === "private"
                    ? "contained"
                    : "outlined"
                }
                onClick={() => {
                  formik.setFieldValue("estType", "private");
                }}
              />
            </Stack>
          </Grid>
        )}
        <Grid container>
          <Grid item xs={12} md={12}>
            <Typography variant="h1" className={globalClasses.typography}>
              Organization Information
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              <Grid item xs={12} md={8}>
                <input
                  type="hidden"
                  id="estType"
                  name="estType"
                  value={formik?.values?.estType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <input
                  type="hidden"
                  id="organizationId"
                  name="organizationId"
                  value={formik?.values?.organizationId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <InputField
                  id="organizationName"
                  name="organizationName"
                  label="Organization Name"
                  uppercase
                  inputvalues={formik.values.organizationName}
                  errormessage={
                    formik.touched.organizationName &&
                    Boolean(formik.errors.organizationName)
                  }
                  message={
                    formik.touched.organizationName &&
                    formik.errors.organizationName
                  }
                  changeevent={formik.handleChange}
                  blurevent={(event: any, value: any) => {
                    formik.handleBlur("organizationName")(event);
                    checkDuplicate(event.target.value);
                  }}
                  isrequired={true}
                  readOnly={mode === "edit" ? true : false}
                  disable={mode === "edit" ? true : false}
                />
                {isEstablishmentPresent && (
                  <Typography
                    color="#d32f2f"
                    component={"p"}
                    variant="subtitle2"
                    sx={{ fontSize: "12px", padding: "5px" }}
                  >
                    Organization already exists
                  </Typography>
                )}
              </Grid>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              <Grid item xs={12} md={8}>
                <Autocomplete
                  freeSolo
                  disableClearable
                  id="searchDistrict"
                  options={fetchDistrict}
                  getOptionLabel={(district: any) => district.adlAddress2 ?? ""}
                  renderOption={(props: any, district: any) => (
                    <Box component="li" {...props} key={district.adlId}>
                      {district.adlAddress2 +
                        "," +
                        district.adlAddress3 +
                        ", " +
                        district.adlAddress4 +
                        ", " +
                        district.adlAddress6}
                    </Box>
                  )}
                  loading={isLoading}
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue(
                      "district",
                      newValue.adlAddress2 ?? ""
                    );
                    formik.setFieldValue("town", newValue.adlAddress3 ?? "");
                    formik.setFieldValue("county", newValue.adlAddress4 ?? "");
                    formik.setFieldValue("country", newValue.adlAddress6 ?? "");
                    setFetchDistrict([]);
                  }}
                  size="small"
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      id="searchDistrict"
                      name="searchDistrict"
                      label="District search"
                      variant="outlined"
                      size="small"
                      value={formik.values.searchDistrict}
                      onChange={(event: any) => {
                        formik.handleChange("searchDistrict")(event);
                        searchDistrict(event);
                      }}
                      onBlur={(event: any) => {
                        formik.handleBlur("searchDistrict")(event);
                        searchDistrict(event);
                      }}
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                      }}
                      autoComplete="off"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={8}>
                <InputField
                  id="numberRoad"
                  name="numberRoad"
                  label="Number & Road"
                  inputvalues={formik.values.numberRoad}
                  errormessage={
                    formik.touched.numberRoad &&
                    Boolean(formik.errors.numberRoad)
                  }
                  message={
                    formik.touched.numberRoad && formik.errors.numberRoad
                  }
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>

              <Grid item xs={12} md={8}>
                <InputField
                  id="district"
                  name="district"
                  label="District"
                  disable={true}
                  inputvalues={formik.values.district}
                  errormessage={
                    formik.touched.district && Boolean(formik.errors.district)
                  }
                  message={formik.touched.district && formik.errors.district}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <InputField
                  id="town"
                  name="town"
                  label="Town"
                  inputvalues={formik.values.town}
                  errormessage={
                    formik.touched.town && Boolean(formik.errors.town)
                  }
                  message={formik.touched.town && formik.errors.town}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <InputField
                  id="county"
                  name="county"
                  label="County"
                  inputvalues={formik.values.county}
                  errormessage={
                    formik.touched.county && Boolean(formik.errors.county)
                  }
                  message={formik.touched.county && formik.errors.county}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <SelectField
                  id="country"
                  name="country"
                  headerText="Select Country"
                  label="Select Country"
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  value={formik.values.country}
                  error={
                    formik.touched.country && Boolean(formik.errors.country)
                  }
                  isrequired={true}
                  list={countries.map((country: any) => (
                    <MenuItem key={country.couId} value={country.couCountry}>
                      {country.couCountry}
                    </MenuItem>
                  ))}
                />

                {formik.touched.country && formik.errors.country && (
                  <Typography
                    color="#d32f2f"
                    component={"p"}
                    variant="subtitle2"
                    sx={{ fontSize: "12px", padding: "5px" }}
                  >
                    {formik.errors.country}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={8}>
                <InputField
                  id="phoneNo"
                  name="phoneNo"
                  label="Phone Number"
                  type="number"
                  inputvalues={formik.values.phoneNo}
                  errormessage={
                    formik.touched.phoneNo && Boolean(formik.errors.phoneNo)
                  }
                  message={formik.touched.phoneNo && formik.errors.phoneNo}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  downevent={restictDotHyphenAnde}
                  isrequired={true}
                  placeholder="e.g. 7777777"
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <InputField
                  id="mobile"
                  name="mobile"
                  label="Mobile"
                  type="number"
                  inputvalues={formik.values.mobile}
                  errormessage={
                    formik.touched.mobile && Boolean(formik.errors.mobile)
                  }
                  message={formik.touched.mobile && formik.errors.mobile}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  downevent={restictDotHyphenAnde}
                  placeholder="e.g. 8888888888"
                />
              </Grid>

              <Grid item xs={12} md={8}>
                <InputField
                  id="emailId"
                  name="emailId"
                  label="Email"
                  inputvalues={formik.values.emailId}
                  errormessage={
                    formik.touched.emailId && Boolean(formik.errors.emailId)
                  }
                  message={formik.touched.emailId && formik.errors.emailId}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                  disable={verifySuccess === "verify" ? true : false}
                />
              </Grid>
              {mode !== "edit" && (
                <Grid item xs={12} md={8}>
                  <ButtonComponent
                    className={classes.darkbluebutton}
                    label="Verify Email"
                    onClick={() => {
                      setIsCodeInvalid(false);
                      setVerifySuccess("");
                      sendVerificationCode(formik.values);
                    }}
                    disable={verifySuccess === "verify" ? true : false}
                  />
                </Grid>
              )}
            </Stack>
          </Grid>
        </Grid>
      </CommonCard>

      <Backdrop open={isSendingEmail}>
        {openDialog && (isSendingEmail || isVerificationCode) && (
          <DialogCard
            class={
              isSendingEmail
                ? `${classes.verifyLoader} ${classes.dialogcontenttextfirst}`
                : classes.dialogcontenttextfirst
            }
            open={openDialog}
            handleCloseDialog={() => {
              setIsVerificationCode(false);
              setIsSendingEmail(false);
              setOpenDialog(false);
              formik.setFieldValue("verificationCode", "");
            }}
            contentText={
              isSendingEmail
                ? "Please wait for your e-mail to be verified."
                : isVerificationCode && "Enter Verification Code"
            }
            showClose={isSendingEmail ? false : true}
          >
            {isSendingEmail && (
              <CircularProgress
                color="primary"
                sx={{ position: "absolute", marginTop: "-95px", left: "45%" }}
              />
            )}
            {isVerificationCode && (
              <>
                <InputField
                  id="verificationCode"
                  name="verificationCode"
                  label="Verification Code"
                  inputvalues={formik.values.verificationCode}
                  errormessage={
                    formik.touched.verificationCode &&
                    Boolean(formik.errors.verificationCode)
                  }
                  message={
                    formik.touched.verificationCode &&
                    formik.errors.verificationCode
                  }
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                />
                {isCodeInvalid && verifySuccess === "notverify" && (
                  <Typography className={classes.typographyincorrect}>
                    Incorrect verification code.
                  </Typography>
                )}
                <Typography className={classes.typographymsg}>
                  A verification code has been sent to your registered e-mail.
                  This verification code will expire in 10 minutes after time of
                  received.
                  <DoneAllIcon className={classes.doneallicon} />
                </Typography>

                <Grid item>
                  {isShowButton && (
                    <ButtonComponent
                      className={classes.darkbluebutton}
                      sx={{ float: "left" }}
                      label="Resend Code"
                      onClick={() => {
                        sendVerificationCode(formik.values);
                        setIsVerificationCode(false);
                        setIsCodeInvalid(false);
                        setVerifySuccess("");
                      }}
                      buttontitle="Resend Code"
                    />
                  )}
                </Grid>
                <Grid item>
                  <ButtonComponent
                    className={classes.darkbluebutton}
                    label=" Verify"
                    onClick={() => {
                      checkVerificationCode(formik.values);
                    }}
                  />
                </Grid>
              </>
            )}
          </DialogCard>
        )}
      </Backdrop>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 1500,
          display: "flex",
          flexDirection: "column",
        }}
        open={open}
        onClick={() => {
          setOpen(false);
        }}
      >
        <Typography fontWeight="600" fontSize="20px">
          Loading Organization Information...!
        </Typography>
        <CircularProgress color="primary" sx={{ margin: "20px" }} />
      </Backdrop>
    </React.Fragment>
  );
};

export default OrganizationInfo;
